(function($) {
    $(() => {

        $('.icon-headline--accordion').click(function(){
            if($(window).width() < 992) {
                $('.icon-headline__text', this).slideToggle(200);
                $('.icon-headline__arrow', this).toggleClass('is-opened');
            }
        });
        
    });
})(jQuery);
